import getSankeyChartDataApi from '../apis';

const getSankeyChartData = async ({ request1, request2 }) => {
  try {
    // https://linear.app/peoplemesh/issue/ENG-17343/update-review-page-apis-request-to-filter-reviewtype
    const request_1 = request1;
    const request_2 = request2;
    if (request_1?.source?.reviewType) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { reviewType, ...sourceWithoutReviewType } = request_1.source;
      request_1.source = sourceWithoutReviewType;
    }
    if (request_2?.source?.reviewType) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { reviewType, ...sourceWithoutReviewType } = request_2.source;
      request_2.source = sourceWithoutReviewType;
    }

    const res = await getSankeyChartDataApi({ request1: request_1, request2: request_2 });
    const data = res?.entity;
    return data;
  } catch (error) {
    console.error('Error fetching review insights chart data : ', error);
  }

  return null;
};

export default getSankeyChartData;
